var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99959 3C11.2604 3.00013 13.2458 5.138 14.232 6.625C14.7995 7.48094 14.7978 8.56935 14.2252 9.42188C13.2367 10.8932 11.2532 12.9999 7.99959 13C4.74624 12.9998 2.76344 10.8932 1.77498 9.42188C1.20222 8.56929 1.19954 7.481 1.76717 6.625C2.75329 5.13802 4.73867 3.00021 7.99959 3ZM7.99959 5C6.34289 5.00018 4.99959 6.34326 4.99959 8C4.99959 9.65674 6.34289 10.9998 7.99959 11C9.65645 11 10.9996 9.65685 10.9996 8C10.9996 6.34315 9.65645 5 7.99959 5Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeView);
export default __webpack_public_path__ + "static/media/eye-view.7cbb5d76240195dab837089b3cb576f4.svg";
export { ForwardRef as ReactComponent };